<template>
  <div class="rounded-xl border border-solid border-main-gray p-4">
    <slot />
  </div>
</template>
